import React  from 'react';
import { SearchJob } from '@app/src/common/SearchJob';

export const renderSearchJob = ({
  input,
  handleChange,
  handleBlur,
  meta: {touched, error},
  handleClickClose,
  defaultJob,
  disabled,
  isLoading,
  dataList,
  handleChangeInput,
  handleClickOpenModal,
  message,
  placeholder,
  isLoadingModal,
  activeColor,
  minCharForSearch,
  lastWordFound
}) => {
  const handleBlurProp = () => {
    input.onBlur && input.onBlur();
    handleBlur && handleBlur();
  }

  const onChangeProp = (e) => {
    handleChangeInput && handleChangeInput(e);
    if (defaultJob) {
      input.onChange && input.onChange(e);
    }
  }

  return(
    <SearchJob
      input={input}
      defaultJob={defaultJob}
      handleChange={handleChange}
      handleBlurInput={handleBlurProp}
      handleChangeInput={onChangeProp}
      handleClickOpenModal={handleClickOpenModal}
      error={touched && error}
      handleClickClose={handleClickClose}
      disabled={disabled}
      isLoading={isLoading}
      isLoadingModal={isLoadingModal}
      dataList={dataList}
      message={message}
      placeholder={placeholder}
      activeColor={activeColor}
      minCharForSearch={minCharForSearch}
      lastWordFound={lastWordFound}
    />
)};
